// extracted by mini-css-extract-plugin
export var expandIcon = "fz_vL";
export var rotated = "fz_vM";